import React from "react";
import PropTypes from "prop-types";
import pick from "lodash/pick";
import isEmpty from "lodash/isEmpty";

import { prismicImage } from "src/common/utils/prismic-image";
import { getBreakpointQuery } from "src/common/config/breakpoints";

import "./ResponsiveImage.scss";

// prettier-ignore
const renderResponsiveSources = responsiveImages =>
  !isEmpty(responsiveImages) &&
  Object.keys(responsiveImages)
    .map(key => (
      <source
        key={key}
        media={getBreakpointQuery(key)}
        srcSet={prismicImage(responsiveImages[key], { q: 80 })}
        sizes={`${responsiveImages[key].dimensions.width / 2}px`}
      />
    ));

const ResponsiveImage = (props) => (
  <picture className="responsive-image">
    {renderResponsiveSources(
      pick(props.images, ["mobile", "fablet", "tablet"])
    )}
    <img
      loading="lazy"
      src={prismicImage(props.images, { q: 80 })}
      alt={props.images.alt || props.alt || ""}
      className={props.className}
      width="100%"
    />
  </picture>
);

ResponsiveImage.propTypes = {
  images: PropTypes.shape({
    url: PropTypes.string.isRequired,
    dimensions: PropTypes.shape({
      width: PropTypes.number.isRequired,
      height: PropTypes.number.isRequired,
    }).isRequired,
    copyright: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  className: PropTypes.string,
  alt: PropTypes.string,
};

export default ResponsiveImage;
